<template>
  <div class="data-grid-search-select">
    <el-select v-if="pageable"
               ref="select"
               v-model="selectValue"
               :multiple="multiple"
               :filterable="true"
               clearable
               collapse-tags
               reserve-keyword
               :placeholder="column.name"
               :loading="loading"
               loading-text="数据加载中..."
               no-match-text="没有匹配数据"
               popper-class="data-grid-search-select-multiple-popper"
               :filter-method="filterGridSelectPageData"
               @visible-change="selectPopoverVisibleChange"
               style="width: 100%">
      <template v-if="columnOptions">
        <el-option v-for="option in columnOptions"
                   :key="option.propKey || option.propValue"
                   :label="option.propLabel"
                   :value="option.propValue">
        </el-option>
      </template>
      <template v-show="!loading">
        <div class="el-select-dropdown__empty" v-if="!columnOptions">
          <span>数据获取失败<a class="theme-text" href="javascript:;" @click="loadGridSelectPageData">重新加载</a></span>
        </div>
        <div class="el-select-dropdown__empty" v-else-if="columnOptions.length === 0">
          <span>返回数据为空</span>
        </div>
      </template>
      <el-pagination
        small
        :page-size.sync="pageSize"
        :current-page.sync="pageIndex"
        :total="totalCount"
        :pager-count="pagerCount"
        layout="prev, pager, next, ->, total"
        @size-change="paginationPageChange"
        @current-change="paginationPageChange">
      </el-pagination>
    </el-select>
    <el-select v-else
               ref="select"
               v-model="selectValue"
               :multiple="multiple"
               :filterable="columnOptions && columnOptions.length > 0"
               clearable
               collapse-tags
               reserve-keyword
               :placeholder="column.name"
               :loading="loading"
               loading-text="数据加载中..."
               no-match-text="没有匹配数据"
               popper-class="data-grid-search-select-popper"
               @focus="expandGridSelectData"
               style="width: 100%">
      <template v-if="!loading">
        <div class="search-all"
             v-if="multiple && columnOptions && columnOptions.length">
          <div class="check-all">全选（{{checkCount}}/{{columnOptions.length}}）</div>
          <div class="checkbox">
            <el-checkbox v-model="isCheckAll"
                         :indeterminate="isIndeterminate"></el-checkbox>
          </div>
        </div>
      </template>
      <template v-if="columnOptions">
        <el-option v-for="option in columnOptions"
                   :key="option.propKey || option.propValue"
                   :label="option.propLabel"
                   :value="option.propValue">
        </el-option>
      </template>
      <template v-if="!loading">
        <div class="el-select-dropdown__empty" v-if="!columnOptions">
          <span>数据获取失败<a class="theme-text" href="javascript:;" @click="expandGridSelectData">重新加载</a></span>
        </div>
        <div class="el-select-dropdown__empty" v-else-if="columnOptions.length === 0">
          <span>返回数据为空</span>
        </div>
      </template>
    </el-select>
  </div>
</template>

<script>
import { getValueByPath } from 'element-ui/lib/utils/util'
import baseApiUrl from '../../../constants/baseApiUrl'
import routeConfig from '../../../constants/routeConfig'
export default {
  name: 'DataGridSearchSelect',
  props: {
    value: {
      required: true
    },
    column: {
      type: Object,
      required: true
    },
    keyProp: {
      type: String
    },
    labelProp: {
      type: String,
      required: true
    },
    valueProp: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    pageable: {
      type: Boolean
    }
  },
  data () {
    return {
      loading: false,
      fetched: false,
      optionList: null,
      pageIndex: 1,
      pageSize: 8,
      pagerCount: 5,
      totalCount: 0,
      query: null
    }
  },
  computed: {
    columnOptions: function () {
      let optionList = this.optionList
      if (optionList) {
        return optionList.map(option => {
          return {
            propKey: this.keyProp ? getValueByPath(option, this.keyProp) : null,
            propLabel: getValueByPath(option, this.labelProp || 'key'),
            propValue: getValueByPath(option, this.valueProp || 'value')
          }
        })
      } else {
        return null
      }
    },
    filterOptions: function () {
      let select = this.$refs.select
      if (select) {
        let options = select.options
        if (options) {
          return options.filter(option => option.visible)
        }
      }
    },
    checkCount () {
      if (Array.isArray(this.value)) {
        return this.value.length
      }
      return 0
    },
    isCheckAll: {
      get () {
        if (this.columnOptions) {
          return this.columnOptions.length === this.checkCount
        }
      },
      set (val) {
        if (val && this.filterOptions) {
          this.$emit('input', this.filterOptions.map(option => option.value))
        } else {
          this.$emit('input', [])
        }
      }
    },
    isIndeterminate () {
      if (this.columnOptions) {
        let checkCount = this.checkCount
        return checkCount > 0 && checkCount < this.columnOptions.length
      }
    },
    selectValue: {
      get () {
        const value = this.value
        let getVal
        if (this.multiple) {
          if (Array.isArray(value)) {
            getVal = value
          } else {
            getVal = value ? [value] : []
          }
        } else {
          if (Array.isArray(value)) {
            getVal = value.length ? value[0] : null
          } else {
            getVal = value
          }
        }
        return getVal
      },
      set (value) {
        let setVal
        if (this.multiple) {
          setVal = value
        } else {
          setVal = value ? [value] : []
        }
        this.$emit('input', setVal)
      }
    }
  },
  methods: {
    // 展开下拉框
    expandGridSelectData () {
      if (!this.loading && !this.fetched) {
        let postParams = this.$extend(this.$attrs)
        if (!postParams[routeConfig.DataGrid.param]) {
          return
        }
        this.loading = true
        let params = this.$extend({
          requestType: 'dropDown',
          prop: this.column.prop
        }, postParams)
        this.$ajax({
          url: baseApiUrl.DataGridUrl,
          method: 'post',
          data: this.$qs.stringify(params, {
            arrayFormat: 'repeat'
          })
        }).then((response) => {
          if (response.data) {
            this.optionList = response.data['optionList']
            if (response.data['message'] && response.data['responseCode'] !== 'SUCCESS') {
              this.$message.error('下拉数据加载出错')
            }
          }
          this.fetched = true
        }).finally(() => {
          this.loading = false
        })
      }
    },
    // 加载分页数据
    loadGridSelectPageData () {
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataGrid.param]) {
        return
      }
      this.loading = true
      let params = this.$extend({
        requestType: 'dropDown',
        prop: this.column.prop,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        query: this.query || ''
      }, postParams)
      this.$ajax({
        url: baseApiUrl.DataGridUrl,
        method: 'post',
        data: this.$qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        if (response.data) {
          this.optionList = response.data['optionList']
          this.totalCount = response.data['totalCount'] || 0
          if (response.data['message'] && response.data['responseCode'] !== 'SUCCESS') {
            this.$message.error('下拉数据加载出错')
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 下拉框显示隐藏
    selectPopoverVisibleChange (visible) {
      if (visible) {
        this.loadGridSelectPageData()
      } else {
        this.query = null
      }
    },
    // 分页搜索
    filterGridSelectPageData (query) {
      this.query = query
      this.loadGridSelectPageData()
    },
    // 分页参数改变
    paginationPageChange () {
      this.loadGridSelectPageData()
    }
  },
  activated () {
    let select = this.$refs.select
    if (select) {
      let inputWidth = select.inputWidth
      if (inputWidth) {
        let popper = select.$refs.popper
        // 解决某些情况下弹出框最小宽度问题
        if (popper && popper.minWidth === '0px') {
          popper.minWidth = `${inputWidth}px`
        }
      }
    }
  },
  deactivated () {
    // 切换页面后重新加载
    this.fetched = false
  }
}
</script>

<style lang="scss">
  .data-grid-search-select {
    & > .el-select {
      width: 100%;
      .el-input--mini {
        .el-input__inner {
          height: 28px!important;
        }
      }
      .el-input--small {
        .el-input__inner {
          height: 32px!important;
        }
      }
      .el-input--medium {
        .el-input__inner {
          height: 36px!important;
        }
      }
    }
  }
  .el-select-dropdown {
    overflow: hidden!important;
    &.data-grid-search-select-multiple-popper {
      .el-select-dropdown__wrap {
        max-height: 350px!important;
        .el-select-dropdown__list {
          padding-bottom: 0!important;
          .el-pagination {
            position: sticky;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 1;
            background-color: #fff;
          }
        }
      }
    }
    &.data-grid-search-select-popper {
      overflow: hidden!important;
      .el-select-dropdown__wrap {
        max-height: 320px!important;
        .el-select-dropdown__list {
          .search-all {
            position: sticky;
            top: 6px;
            left: 0;
            right: 0;
            z-index: 1;
            background-color: #fff;
            height: 32px;
            line-height: 32px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px 6px;
            font-size: 12px;
            & > .check-all {
              color: #303133;
            }
          }
        }
      }
    }
    .el-select-dropdown__wrap {
      .el-select-dropdown__list {
        .el-select-dropdown__item {
          &.hidden-option {
            display: none;
          }
        }
        .el-pagination {
          padding: 6px 4px;
          border-top: 1px solid rgba(0,0,0,.03);
          .el-pagination__rightwrapper {
            .el-pagination__total {
              font-size: 12px;
            }
          }
          .btn-prev,
          .btn-next {
            padding: 0 6px;
            background-color: transparent;
          }
          .el-pager {
            & > li {
              font-weight: normal;
              background-color: transparent;
            }
          }
        }
      }
    }
    .el-select-dropdown__empty {
      padding: 40px 0;
      a {
        margin: 0 4px;
        text-decoration: none;
      }
    }
  }
</style>
